import { useSyncExternalStore } from 'react'

const donkerQuery = window.matchMedia('(prefers-color-scheme: dark)')

function subscribe(callback: () => void): () => void {
  donkerQuery.addEventListener('change', callback)
  const observer = new MutationObserver(callback)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
  return () => {
    donkerQuery.removeEventListener('change', callback)
    observer.disconnect()
  }
}

function huidigThema(): 'light' | 'dark' {
  const gekozen = document.documentElement.dataset.theme
  if (gekozen === 'dark' || gekozen === 'light') return gekozen
  return donkerQuery.matches ? 'dark' : 'light'
}

export function useThema(): 'light' | 'dark' {
  return useSyncExternalStore(subscribe, huidigThema)
}
